module.exports = __webpack_public_path__ + "img/goin4.9e12ffbe.png";